/** Shared EN/FA copy for revision-bound bulk review decisions. */
export const bulkReviewCopy = {
  en: {
    selectAll: 'Select all eligible items on this page',
    selectOne: 'Select {{name}}',
    selected: '{{count}} selected',
    approve: 'Approve selected',
    reject: 'Reject selected',
    publish: 'Publish selected',
    approveReady: 'Approve pending ({{count}})',
    approvalProgress: '{{approved}} of {{total}} approved',
    publishNeedsAll: 'Approve every selected revision before publishing.',
    checkingStatus: 'Checking current revision status…',
    retryStatus: 'Retry status check',
    clearSelection: 'Clear selection',
    fixInvalid: 'One or more selected revisions need fixes before approval.',
    status: {
      approved: 'Approved', pending: 'Needs approval', invalid: 'Needs fixes',
      unavailable: 'Unavailable', loading: 'Checking…',
    },
    title: {
      approve: 'Approve {{count}} selected items?',
      reject: 'Reject {{count}} selected items?',
      publish: 'Publish {{count}} approved revisions?',
    },
    description: {
      approve: 'Every item is checked against its current server revision before approval.',
      reject: 'Every item is checked before rejection. A reason is optional.',
      publish: 'Only revisions with a matching human approval can publish. Existing versions and slides remain unchanged.',
    },
    reasonLabel: 'Reason (optional, applied to each selected item)',
    reasonPlaceholder: 'Explain the review decision…',
    more: 'and {{count}} more',
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'Confirm {{action}}',
    progress: 'Processing {{done}} of {{total}}…',
    finished: '{{succeeded}} succeeded, {{failed}} could not be processed.',
    failedHeading: 'Needs individual attention',
    unavailable: 'This action is no longer available. Refresh and review the item.',
    stale: 'The revision changed since selection. Review it individually.',
    invalid: 'This draft has validation errors. Fix them before approval.',
    alreadyApproved: 'This draft is already approved. You can publish it.',
    needsApproval: 'This revision needs approval before publishing.',
    warnings: 'This proposal has warnings; review them individually before approving.',
    serverRefused: 'Server refused the operation ({{code}}).',
    unknownError: 'The action failed. Review the item and try again.',
    templatesListLabel: 'Unfinished template forks',
    aiSelection: 'Choose proposals to review together',
  },
  fa: {
    selectAll: 'انتخاب همه موارد مجاز در این صفحه',
    selectOne: 'انتخاب {{name}}',
    selected: '{{count}} مورد انتخاب شده',
    approve: 'تأیید انتخاب‌شده‌ها',
    reject: 'رد انتخاب‌شده‌ها',
    publish: 'انتشار انتخاب‌شده‌ها',
    approveReady: 'تأیید در انتظار ({{count}})',
    approvalProgress: '{{approved}} از {{total}} نسخه تأیید شده',
    publishNeedsAll: 'برای انتشار باید همه نسخه‌های انتخاب‌شده تأیید شوند.',
    checkingStatus: 'در حال بررسی وضعیت نسخه‌ها…',
    retryStatus: 'بررسی دوباره وضعیت',
    clearSelection: 'پاک کردن انتخاب‌ها',
    fixInvalid: 'بعضی نسخه‌های انتخاب‌شده پیش از تأیید به اصلاح نیاز دارند.',
    status: {
      approved: 'تأییدشده', pending: 'نیازمند تأیید', invalid: 'نیازمند اصلاح',
      unavailable: 'نامعتبر', loading: 'در حال بررسی…',
    },
    title: {
      approve: 'تأیید {{count}} مورد انتخاب‌شده؟',
      reject: 'رد {{count}} مورد انتخاب‌شده؟',
      publish: 'انتشار {{count}} نسخه تأییدشده؟',
    },
    description: {
      approve: 'پیش از تأیید، نسخه فعلی هر مورد از سرور دوباره بررسی می‌شود.',
      reject: 'پیش از رد، نسخه فعلی هر مورد بررسی می‌شود. درج دلیل اختیاری است.',
      publish: 'تنها نسخه‌هایی با تأیید انسانی معتبر منتشر می‌شوند؛ نسخه‌های قبلی و اسلایدها تغییر نمی‌کنند.',
    },
    reasonLabel: 'دلیل (اختیاری؛ برای همه موارد انتخاب‌شده)',
    reasonPlaceholder: 'دلیل تصمیم بازبینی را بنویسید…',
    more: 'و {{count}} مورد دیگر',
    cancel: 'انصراف',
    close: 'بستن',
    confirm: 'تأیید عملیات: {{action}}',
    progress: 'در حال پردازش {{done}} از {{total}}…',
    finished: '{{succeeded}} مورد موفق، {{failed}} مورد انجام نشد.',
    failedHeading: 'نیازمند بررسی جداگانه',
    unavailable: 'این عملیات دیگر مجاز نیست. مورد را تازه‌سازی و بررسی کنید.',
    stale: 'نسخه پس از انتخاب تغییر کرده است؛ جداگانه بررسی کنید.',
    invalid: 'این پیش‌نویس خطای اعتبارسنجی دارد. پیش از تأیید آن را اصلاح کنید.',
    alreadyApproved: 'این نسخه قبلاً تأیید شده است و می‌توان آن را منتشر کرد.',
    needsApproval: 'پیش از انتشار باید این نسخه تأیید شود.',
    warnings: 'این پیشنهاد هشدار دارد؛ پیش از تأیید هشدارها را جداگانه بررسی کنید.',
    serverRefused: 'سرور عملیات را نپذیرفت ({{code}}).',
    unknownError: 'عملیات انجام نشد. مورد را بررسی و دوباره تلاش کنید.',
    templatesListLabel: 'فورک‌های نیمه‌تمام قالب',
    aiSelection: 'انتخاب چند پیشنهاد برای بازبینی گروهی',
  },
} as const;
